import EcommerceMetrics from "../../components/ecommerce/EcommerceMetrics";
import MonthlySalesChart from "../../components/ecommerce/MonthlySalesChart";
import StatisticsChart from "../../components/ecommerce/StatisticsChart";
import MonthlyTarget from "../../components/ecommerce/MonthlyTarget";
import RecentOrders from "../../components/ecommerce/RecentOrders";
import DemographicCard from "../../components/ecommerce/DemographicCard";
import PageMeta from "../../components/common/PageMeta";
import { useNavigate } from "react-router";
import { getItem } from "../../utils/storage";
import { useEffect, useState } from "react";
import CountCards from "../../components/Dashboard/CountCards";
import VehiclesOverview from "../../components/Dashboard/VehiclesOverview";
import DropedTrailer from "../../components/Dashboard/DropedTrailer";
import TopCitis from "../../components/Dashboard/TopCities";
import { useAxios } from "../../utils/useAxios";
import Shipper from "./Shipper";

export default function Ecommerce() {
  const navigate = useNavigate();
  const isAuthenticated = getItem("user");

  const [list, setList] = useState([]);
  const { res, mutate, isPending, error } = useAxios({
    url: "/api/auth/inventoryHistory",
    onSuccess: (data) => {
      setList(data?.data);
      console.log(data?.data);
    },
  });
  useEffect(() => {
    mutate({
      getTrailerlist: true,
      table: "InventoryHistory",
    });
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <PageMeta title="TTM Dashboard | Admin Dashboard" description="" />
      <div className="grid grid-cols-12 gap-4 md:gap-6">
        <CountCards list={list} />
        <div className="col-span-12 xl:col-span-6">
          <TopCitis />
        </div>

        <div className="col-span-12 xl:col-span-6">
          <VehiclesOverview />
        </div>
        <div className="col-span-12 xl:col-span-12">
          <DropedTrailer list={list} />
        </div>
        {/* <div className="col-span-12 xl:col-span-12">
          <Shipper />
        </div> */}

        {/* <div className="col-span-12 space-y-6 xl:col-span-7">
          <EcommerceMetrics />

          <MonthlySalesChart />
        </div> */}

        {/* <div className="col-span-12 xl:col-span-5">
          <MonthlyTarget />
        </div> */}

        {/* <div className="col-span-12">
          <StatisticsChart />
        </div> */}

        {/* <div className="col-span-12 xl:col-span-5">
          <DemographicCard />
        </div> */}

        {/* <div className="col-span-12 xl:col-span-12">
          <RecentOrders />
        </div> */}
      </div>
    </>
  );
}
